// CartView.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Badge } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';


const CartView = () => {
    const navigate = useNavigate();

   const { cart , loadCartFromServer } = useCart() || [];
     const { user } = useAuth();
const totalQuantity = cart?.reduce((sum, i) => sum + (Number(i?.quantity) || 0), 0) || 0;

  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
  } = user || {};
    
  
    return (
        <div style={{
            position: 'fixed',
            top: 80,
            right: 0,
            padding: '10px',
            backgroundColor: '#fff',
            zIndex: 1000,
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
            <IconButton onClick={() => navigate('/cart')} color="inherit">
                 <Badge badgeContent={totalQuantity} color="secondary">
                   <img src={cart.length > 0 ? "../images/filledsack.png" : "../images/emptysack.png"} 
            alt="Cart" 
            style={{ width: 24, height: 24 }} 
            />
              </Badge>
            </IconButton>
        </div>
    );
};

export default CartView;
